import {
    UPDATE_QUESTIONAIRE_QUESTION,
    UPDATE_QUESTIONAIRE_QUESTION_SUCCESSFUL,
    UPDATE_QUESTIONAIRE_QUESTION_FAILED,
    UPDATE_QUESTIONAIRE_QUESTION_RESET,
} from "./actionsType"

const initialState = {
    message: null,
    loading: false,
    questionData: null,
    updateError: null,
    updateSuccess: false
}

const questionaireQuestionEdit = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_QUESTIONAIRE_QUESTION:
            state = {
                ...state,
                loading: true,
                updateSuccess: false,
                updateError: null,
            }
            break
        case UPDATE_QUESTIONAIRE_QUESTION_SUCCESSFUL:
            state = {
                ...state,
                loading: false,
                questionData: action.payload,
                updateSuccess: true,
                updateError: null,
            }
            break
        case UPDATE_QUESTIONAIRE_QUESTION_FAILED:
            state = {
                ...state,
                questionData: null,
                loading: false,
                updateSuccess: false,
                updateError: action.payload,
            }
            break
        case UPDATE_QUESTIONAIRE_QUESTION_RESET:
            state = {
                ...state,
                message: null,
                loading: false,
                updateError: null,
                updateSuccess: false
            }
            break
        default:
            state = { ...state }
            break
    }
    return state
}

export default questionaireQuestionEdit